import serverProfiles from './server-profile.json';

const profileName = process.env.REACT_APP_PROFILE ;

export default serverProfiles[profileName];